import React from 'react';
import {
	AutocompleteInput,
	BooleanInput,
	Create,
	ReferenceInput,
	required,
	SimpleForm,
	TextInput,
} from 'react-admin';

export const ProjectCreate = (props: any) => (
	<Create {...props}>
		<SimpleForm>
			<TextInput source="name" />
			<BooleanInput source="withDatawarehouse" />
			<TextInput source="datawarehouseProjectId" />
			<ReferenceInput
				label="User"
				source="userId"
				reference="users"
				perPage={25}
				filterToQuery={(searchText: string) => ({ q: searchText })}
			>
				<AutocompleteInput optionText="name" validate={required()} />
			</ReferenceInput>
			<ReferenceInput
				label="Billing Account"
				source="billingAccountId"
				reference="billing-accounts"
				perPage={25}
				filterToQuery={(searchText: string) => ({ q: searchText })}
			>
				<AutocompleteInput optionText="name" validate={required()} />
			</ReferenceInput>
		</SimpleForm>
	</Create>
);
